import { useState } from 'react';
import desktopPreview from '../imagesHome/laptop_contalearn.png';
import phonePreview from '../imagesHome/iphone_background.png';
import tabletPreview from '../imagesHome/tablet_contalearn.png';
import './LearnAnywhere.css';

function DeviceIcon({ device }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {device === 'laptop' ? (
        <>
          <rect x="4" y="4" width="16" height="12" rx="1.5" />
          <path d="M4 16 2 20h20l-2-4M9 20h6" />
        </>
      ) : device === 'tablet' ? (
        <>
          <rect x="3" y="2" width="18" height="20" rx="2.5" />
          <path d="M10 19h4" />
        </>
      ) : (
        <>
          <rect x="6" y="2" width="12" height="20" rx="2.5" />
          <path d="M10 5h4M11 19h2" />
        </>
      )}
    </svg>
  );
}

export default function LearnAnywhere({
  desktopImage = desktopPreview,
  phoneImage = phonePreview,
  tabletImage = tabletPreview
}) {
  const [activeDevice, setActiveDevice] = useState('laptop');

  const devices = [
    {
      id: 'laptop',
      label: 'Laptop',
      image: desktopImage,
      alt: 'Previzualizare ContaLearn pe laptop'
    },
    {
      id: 'phone',
      label: 'Telefon',
      image: phoneImage,
      alt: 'Previzualizare ContaLearn pe telefon'
    },
    {
      id: 'tablet',
      label: 'Tableta',
      image: tabletImage,
      alt: 'Previzualizare ContaLearn pe tableta'
    }
  ];

  const selectedDevice = devices.find((device) => device.id === activeDevice);

  return (
    <section
      className="cl-anywhere"
      aria-label="Invata de pe telefon, tableta sau laptop"
    >
      <div className="cl-anywhere__inner">
        <div className="cl-anywhere__copy">
          <h2 className="cl-anywhere__title">
            Inveti de pe telefon, tableta sau laptop
          </h2>
          <p className="cl-anywhere__description">
            Deschide ContaLearn in browser si parcurge lectiile de contabilitate
            in ritmul tau, de pe dispozitivul preferat.
          </p>
          <div
            className="cl-anywhere__switch"
            role="group"
            aria-label="Alege dispozitivul pentru previzualizare"
          >
            {devices.map((device) => (
              <button
                key={device.id}
                type="button"
                className="cl-anywhere__device-button"
                aria-pressed={activeDevice === device.id}
                onClick={() => setActiveDevice(device.id)}
              >
                <DeviceIcon device={device.id} />
                {device.label}
              </button>
            ))}
          </div>
        </div>

        <div className="cl-anywhere__preview">
          <img
            className={`cl-anywhere__image cl-anywhere__image--${activeDevice}`}
            src={selectedDevice.image}
            alt={selectedDevice.alt}
            decoding="async"
          />
        </div>
      </div>
    </section>
  );
}